import { cloneDeep } from 'lodash';
import { routingGTM } from '../../gtm/datalayers/routeDataLayers.json';
import { fireGTM } from '../../gtm/gtmUtil';

export const getPathWithoutTenant = (pathTenantName, pathURLString) => {
  return pathURLString.replace(`/${pathTenantName.toLowerCase()}`, '');
};

export const getTenantNameFromURL = () => {
  const pathname = window.location.pathname.substring(1);
  const tenantName = pathname.slice(0, pathname.indexOf('/')) || 'asu';
  return { tenantName };
};

export const getGTMRoutingObj = (
  routeTenantName,
  fromURLString,
  toURLString
) => {
  const routingGTMCopy = cloneDeep(routingGTM);

  const toURL = toURLString || fromURLString;

  routingGTMCopy.from = getPathWithoutTenant(routeTenantName, fromURLString);
  routingGTMCopy.to = getPathWithoutTenant(routeTenantName, toURL);

  return routingGTMCopy;
};

export const handleFireGTM = async (
  tenantName,
  messageText,
  fromURL,
  toURL
) => {
  const gtmRoutingObj = getGTMRoutingObj(tenantName, fromURL, toURL);

  /*
  Until we get word from ASU what they want the text to be when a different path is triggered 
  bypass any obj.text & obj.section assignments with the !messageText
  */
  await fireGTM(gtmRoutingObj, messageText, '', !messageText);
};
